// FILE for controlling the logic for custom gift cards

const formSelectors = {
  TYPE_PHYSICAL: '#type-physical',                  // gift-card[type]
  TYPE_DIGITAL: '#type-digital',                    // gift-card[type]
  CUSTOM_AMOUNT_INPUT: '#gift-card-custom-amount',  // gift-card[custom-amount]
  SEND_TO_SOMEONE: '#send-to-them',                 // gift-card[send-to]
  SEND_TO_ME: '#send-to-me',                        // gift-card[send-to]
  REMAINING_CHAR: '#remaining-char',                // text below personlised message
  SEND_DATE_NOW: '#send-date-now',                  // gift-card[send-date]
  SEND_DATE_LATER: '#send-date-later',              // gift-card[send-date]
  SCHEDULED_CONTAINER: '#gift-card-scheduling',     // used to hide or show date/hour/mins inputs based on send date option
  SCHEDULED_DATE: '#gift-card-date',                // schedule[date]
  SCHEDULED_HOUR: '#gift-card-hour',                // schedule[hour]
  SCHEDULED_MINUTES: '#gift-card-minutes',          // schedule[minutes]
  PERIOD: '#gift-card-period',                      // schedule[period]
  ADD_TO_CART: '.ProductForm__AddToCart',            // there is two add to cart buttons mobile and desktop.
  NAME_CONTAINER: '#gift-card-recipents-name',
  EMAIL_CONTAINER: '#gift-card-recipents-email',
  ERROR_CUSTOM_AMOUNT: '.custom-amount .property-heading',
  ERROR_CUSTOM_AMOUNT_MESSAGE: '#gift-card-custom-amount-error',
  ERROR_AMOUNT: '.ProductForm__Label.Heading',
  VARIANT_OPTIONS: '.data-giftcard-variant-option',
  VARIANT_OPTIONS_RADIOS: '.data-giftcard-variant-option input',
  VARIANT_OPTIONS_LABELS: '.data-giftcard-variant-option label',
  INVALID: 'invalid-giftcard-form',
  INPUT_ERROR: '.input-error',
  GIFT_CARD_INPUTS: '.js-gift-card-inputs',
  INPUT_INVALID: '.Form__Input.is-invalid'
}

// Required fields for Gift card app.
// Needs to be in the cart line item properties
const giftCardProperties = {
  RECIPIENTS_NAME: '#recipient_name',   // properties[Recipient name]
  RECIPIENTS_EMAIL: '#recipient_email', // properties[Recipient email]
  SCHEDULED_ON: '#scheduled_at',             // properties[Scheduled At]
  GIFT_OPTION: '#gift_option',          // properties[_gift_option]
  CHECKSUM: '#gcp_checksum',            // properties[_gcp_checksum]
  TEMPLATE_ID: '#template_id',          // properties[_template]
  PRODUCT_URL: '#gcp_product_url',

  // message is optional
  MESSAGE: '#message',                  // properties[Message]

  // not required for app but used to set the correct product variant and checkout script
  TYPE: '#giftcard-type',                    // properties[Giftcard Type]
  CUSTOM_AMOUNT: '#giftcard-valid-custom-amount', // properties[Gift Card Value]
}

const classes = {
  ERROR_TEXT: 'ErrorText',
  DISABLE: 'Disable',
  ACTIVE: 'active',
  HIDDEN: 'hidden',
  IS_INVALID: 'is-invalid'
}

// need amount, name and email entered for add to cart to work.
// if not valid disable add to cart button
const validateGiftCardForm = () => {
  const customAmount = document.querySelector(formSelectors.CUSTOM_AMOUNT_INPUT)
  if (customAmount && customAmount.value.length > 0) {
    // console.warn('test custom amount')
    const errorMessage = document.querySelector(formSelectors.ERROR_CUSTOM_AMOUNT_MESSAGE)
    const validInput = validateCustomAmount(customAmount.value, errorMessage)
    // console.warn('validInput: ', validInput)
    if (!validInput) {
      // console.warn('invalid input')
      deselectAmountOptions()
      disableAddToCartButton( false )
      // return true
      // setErrorMessage(formSelectors.CUSTOM_AMOUNT_INPUT)
      // setInvalidFormInput(formSelectors.CUSTOM_AMOUNT_INPUT)
      disableAddToCartButton( true )
      return false
    }
  } else {
    // console.warn('test selected amount')
    // check if there is a selected amount
    const selectedOption = getSelectedAmountOptions()
    if (!selectedOption) {
      deselectAmountOptions()
      // setErrorMessage(formSelectors.ERROR_AMOUNT)
      setInvalidFormInput(formSelectors.ERROR_AMOUNT, true)
      disableAddToCartButton( true )
      return false
    }
  }
  setInvalidFormInput(formSelectors.ERROR_AMOUNT)

  const type = document.querySelector(giftCardProperties.TYPE);
  if (type.value === 'Physical') {
    // only need the amount for physical cards
    // console.warn('Physical cards only require the amount selected.')
    disableAddToCartButton( false )
    return true;
  }

  const name = document.querySelector(giftCardProperties.RECIPIENTS_NAME)
  const nameContainer = document.querySelector(formSelectors.NAME_CONTAINER)
  if (!name || name.value.length === 0) {
    validateErrorInput(nameContainer, true)
    disableAddToCartButton(true, window.languages.productFormAddToCart)
    return false
  }
  validateErrorInput(nameContainer)

  const email = document.querySelector(giftCardProperties.RECIPIENTS_EMAIL)
  const emailContainer = document.querySelector(formSelectors.EMAIL_CONTAINER)
  if (!email || email.value.length === 0) {
    validateErrorInput(emailContainer, true, 'Recipient’s Email is required')
    disableAddToCartButton( true, window.languages.productFormAddToCart)
    return false
  } else {
    if ( !validateEmail(email.value) ) {
      validateErrorInput(emailContainer, true, 'Email is invalid!')
      disableAddToCartButton(true, window.languages.productFormAddToCart)
      return false
    }
  }
  validateErrorInput(emailContainer)


  const date = document.querySelector(formSelectors.SCHEDULED_DATE).value
  const inputDate = new Date(date)
  const today = new Date()
  const sendNow = document.querySelector(formSelectors.SEND_DATE_NOW).checked
  const selectedTimeHour = parseInt(document.querySelector('#gift-card-hour').value, 10)
  const selectedTimeMinutes = parseInt(document.querySelector('#gift-card-minutes').value, 10)
  const selectedTimeAmOrPm = document.querySelector('#gift-card-period').value

  let hour24 = selectedTimeHour
  if (selectedTimeAmOrPm === 'PM' && selectedTimeHour !== 12) {
    hour24 += 12
  } else if (selectedTimeAmOrPm === 'AM' && selectedTimeHour === 12) {
    hour24 = 0
  }

  // Set the selected date with selected time
  inputDate.setHours(hour24, selectedTimeMinutes, 0, 0)

  if (!sendNow && (!date || inputDate.getTime() < today.getTime())) {
    validateErrorDateInput(true)
    disableAddToCartButton(true, window.languages.productFormAddToCart)
    return false
  }

  validateErrorDateInput()

  // if not valid disable add to cart button
  disableAddToCartButton( false )

  return true
}

const validateErrorDateInput = (state = false) => {
  const giftCardScheduling = document.querySelector(formSelectors.SCHEDULED_CONTAINER)
  const inputDate = giftCardScheduling.querySelector(formSelectors.SCHEDULED_DATE)

  if (giftCardScheduling) {
    if (state) {
      giftCardScheduling.classList.add(classes.IS_INVALID)
      inputDate.classList.add(classes.IS_INVALID)
    } else {
      giftCardScheduling.classList.remove(classes.IS_INVALID)
      inputDate.classList.remove(classes.IS_INVALID)
    }
  }
}

const validateErrorInput = (selector, state = false, message = '') => {
  const errorInput = selector.querySelector(formSelectors.INPUT_ERROR)
  const input = selector.querySelector('input')

  if (message && errorInput) {
    errorInput.innerHTML = message
  }

  if (state) {
    errorInput?.classList.add(classes.ACTIVE)
    input.classList.add(classes.IS_INVALID)
  } else {
    errorInput?.classList.remove(classes.ACTIVE)
    input.classList.remove(classes.IS_INVALID)
  }
}

const setErrorMessage = (selector) => {
  document.querySelector(selector).classList.add(classes.ERROR_TEXT)
  setTimeout( () => {
    document.querySelector(selector).classList.remove(classes.ERROR_TEXT)
  }, 2000)
}

const setInvalidFormInput = (selector, value = false) => {
  const input = document.querySelector(selector)
  if (value) {
    input.setAttribute(formSelectors.INVALID, value)
  } else {
    input.removeAttribute(formSelectors.INVALID)
  }
}

// basic check for: anystring@anystring.anystring
const validateEmail = (email) => {
  const emailRegex = /\S+@\S+\.\S+/;
  return emailRegex.test(email);
}

// value: if true add disabled
const disableAddToCartButton = (value, text = 'Select Amount') => {
  // console.warn('updating the add to cart button', value)
  const addToCartButtons = document.querySelectorAll(formSelectors.ADD_TO_CART)

  addToCartButtons.forEach((button) => {
    const ErrorTextMessage = button.querySelector('.ErrorTextMessage')
    if (value) {
      button.setAttribute('gift-card-disabled', value)
      if (ErrorTextMessage) {
        ErrorTextMessage.innerHTML = text
      }
    } else {
      button.removeAttribute('gift-card-disabled')
      if (ErrorTextMessage) {
        ErrorTextMessage.innerHTML = ''
      }
    }
  })
}

const showError = () => {
  validateGiftCardForm()
  const invalidFormInputs = document.querySelectorAll(`[${formSelectors.INVALID}]`)
  invalidFormInputs.forEach((input) => {
    input.classList.add(classes.ERROR_TEXT)
    setTimeout( () => {
      input.classList.remove(classes.ERROR_TEXT)
    }, 2000)
  })
}

// send to: theme/my self button logic
// if (typeof sendToRadios === 'undefined' || sendToRadios === null ) {
//   const sendToRadios = document.getElementsByName("gift-card[send-to]")
//   const isThisGiftCheckbox = document.getElementById("gift_option")
//   for (let i = 0, max = sendToRadios.length; i < max; i++) {
//       sendToRadios[i].onclick = function() {
//           if (sendToRadios[1].checked) {
//             isThisGiftCheckbox.checked = false
//             resetGcpProperties()
//             document.querySelector('#gift-card-postman').classList.remove('active')

//           }
//           if (sendToRadios[0].checked) {
//             isThisGiftCheckbox.checked = true
//             resetGcpProperties()
//             document.querySelector('#gift-card-postman').classList.add('active')
//           }
//           isThisGiftCheckbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
//       }
//   }
// }

// used to select the product varant that is next highest value compared to the entered custom amount
// it cannot exceed the largest product variant price
function selectAmountOptions(customAmount) {
  let productVariantsRadios = document.querySelectorAll(formSelectors.VARIANT_OPTIONS)
  if (!productVariantsRadios) {
    return
  }
  for (const VariantRadio of productVariantsRadios) {
    let amount = VariantRadio.querySelector('.SizeSwatch')
    let number = amount.innerHTML.replace(/[$,]+/g,"");
    number = parseInt(number, 10);
    if (!isNaN(number) && number >= customAmount) {
      let radioEl = VariantRadio.querySelector('.SizeSwatch__Radio')
      radioEl.click()
      return;
    }
  }
}

const deselectAmountOptions = () => {
  let productVariantsRadios = document.querySelectorAll(formSelectors.VARIANT_OPTIONS_RADIOS)
  if (!productVariantsRadios) {
    return
  }
  for (const VariantRadio of productVariantsRadios) {
    VariantRadio.checked = false
  }
}

function selectFirstAmountVariant() {
  let productVariantsRadios = document.querySelectorAll(formSelectors.VARIANT_OPTIONS)
  let radioEl = null
  if (!productVariantsRadios) {
    return
  }
  for (const VariantRadio of productVariantsRadios) {
    const MAX_PRICE = 2000
    let amount = VariantRadio.querySelector('.SizeSwatch')
    let number = amount.innerHTML.replace(/[$,]+/g,"");
    number = parseInt(number, 10);
    if (!isNaN(number) && number < MAX_PRICE) {
      radioEl = VariantRadio.querySelector('.SizeSwatch__Radio')
    }
  }
  if (!radioEl) {
    return
  }
  radioEl.click()
}

function getSelectedAmountOptions() {
  let productVariantsRadios = document.querySelectorAll(formSelectors.VARIANT_OPTIONS_RADIOS)
  if (!productVariantsRadios) {
    return
  }
  for (const VariantRadio of productVariantsRadios) {
    if (VariantRadio.checked) {
      // console.warn('Variant found')
      return VariantRadio.value
    }
  }
}

function isPhysical() {
  return document.querySelector(formSelectors.TYPE_PHYSICAL).checked
}
function sendNow() {
  return document.querySelector(formSelectors.SEND_DATE_NOW).checked
}

function clearScheduleAtInput() {
  let gcp_property_schedule_at = null
  if (isPhysical() || sendNow()) {
    gcp_property_schedule_at = document.querySelectorAll('input[name="properties[Scheduled At]"]')
    resetChecksum()
    gcp_property_schedule_at.forEach((item)=> {
      item.value = ''
    })
  }
}

function onGiftCardTypeOptionClick(event) {
  if (!event) { return }
  const typeInput = event.target.value
  clearForm()
  let giftCardTypeValue = document.querySelector(giftCardProperties.TYPE)
  giftCardTypeValue.value = typeInput
  giftCardTypeValue.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
  if (typeInput === 'Physical') {
    setPhysicalState()
    clearScheduleAtInput()
    setPropertyProduct()
  }
  if (typeInput === 'Digital') {
    setDigitalState()
    disableAddToCartButton(true)
    setPropertyProduct()
  }

  if (isPhysical()) {
    resetChecksum()
    document.querySelectorAll('input[name="properties[_gift_option]"]').forEach((el) => {
      el.checked = false
      el.value = false
    })
  }

  if (window.innerWidth >= 768) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  } else {
    const positionScrollTo = document.querySelector('.js-position-anchor-mobile').offsetTop
    window.scrollTo({
      top: positionScrollTo,
      behavior: "smooth"
    })
  }
}

const resetChecksum = () => {
  const checksum = document.querySelector(giftCardProperties.CHECKSUM)
  if (checksum) {
    checksum.value = ''
  } else {
    console.warn('checksum is not available. cannot clear value')
  }
}

const resetErrorInput = () => {
  const errorInputs = document.querySelectorAll(formSelectors.INPUT_ERROR)
  const inputInvalids = document.querySelectorAll(formSelectors.INPUT_INVALID)

  if (errorInputs) {
    errorInputs.forEach(error => {
      error.classList.remove(classes.ACTIVE)
    })
  }

  if (inputInvalids) {
    inputInvalids.forEach(input => input.classList.remove(classes.IS_INVALID))
  }
}

const setPhysicalState = () => {
  // hide send to, recipients name, recipients email, and send date options
  document.querySelector(formSelectors.NAME_CONTAINER).style.display = 'none'
  document.querySelector(formSelectors.GIFT_CARD_INPUTS).classList.add('gift-card-properties--input-hide')
  document.querySelector('.gcp-form-fields #gift-card-recipents-email').style.display = 'none'
  document.querySelector('.line-item-property__field.send-to').style.display = 'none'
  document.querySelector('.gcp-input-row.send-date').style.display = 'none'
  document.querySelector('.gcp-input-row.gift-card-add-message-btn').style.display = 'block'
  document.querySelector('.gcp-input-row.gift-card-add-message-btn .property-option').innerHTML = 'add personal message'
  document.querySelector(formSelectors.SCHEDULED_CONTAINER).style.display = 'none';
  document.querySelector('.gcp-input-row.message').classList.remove('active')
  document.querySelector(formSelectors.TYPE_PHYSICAL).checked = true
  document.querySelector(giftCardProperties.GIFT_OPTION).checked = false
  disableAddToCartButton(true)
  resetErrorInput()
}

const setDigitalState = () => {
  document.querySelector(formSelectors.NAME_CONTAINER).style.display = 'flex'
  document.querySelector(formSelectors.GIFT_CARD_INPUTS).classList.remove('gift-card-properties--input-hide')
  document.querySelector('.gcp-form-fields #gift-card-recipents-email').style.display = 'flex'
  // document.querySelector('.line-item-property__field.send-to').style.display = 'flex'
  document.querySelector('.gcp-input-row.send-date').style.display = 'flex'
  document.querySelector('.gcp-input-row.gift-card-add-message-btn').style.display = 'none'
  document.querySelector('.gcp-input-row.message').classList.add('active')
  let sendDateEl = document.querySelector(formSelectors.SEND_DATE_NOW)
  if (!sendDateEl.checked) {
    document.querySelector(formSelectors.SCHEDULED_CONTAINER).style.display = 'flex'
  }
  const isThisGiftCheckbox = document.querySelector(giftCardProperties.GIFT_OPTION)
  isThisGiftCheckbox.checked = true
  document.querySelector(formSelectors.TYPE_DIGITAL).checked = true
  isThisGiftCheckbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
}

// return valid input as a number or 0 if not valid
function validateCustomAmount(input, errorMessage) {
  const MAX_GIFT_CARD_AMOUNT = 2000;
  const MIN_GIFT_CARD_AMOUNT = 5;
  const onlyNumbers = /\d+/
  const number = parseInt(input, 10);

  if (!input.match(onlyNumbers)) {
    errorMessage.innerHTML = "Input cannot contain letters or special characters"
    return 0
  } else if (isNaN(number) || number % 5 !== 0) {
    errorMessage.innerHTML = "Please adjust your amount to an increment of $5 (e.g. $55)"
    return 0;
  } else if (number > MAX_GIFT_CARD_AMOUNT) {
    errorMessage.innerHTML = "Amount cannot be greater than $" + MAX_GIFT_CARD_AMOUNT
    return 0;
  } else if (number < MIN_GIFT_CARD_AMOUNT) {
    errorMessage.innerHTML = "Amount cannot be less than $" + MIN_GIFT_CARD_AMOUNT
    return 0;
  }
  // console.warn('number', number)
  return number
}

const handleCustomInputEvent = (event) => {
  // console.warn('handleCustomInputEvent', event)
  let customAmountInput = event.target
  let input = event.target.value
  clearAmountActiveState()
  deselectAmountOptions()
  let giftCardCustomAmountValue = document.querySelector(giftCardProperties.CUSTOM_AMOUNT)
  let errorMessage = document.querySelector(formSelectors.ERROR_CUSTOM_AMOUNT_MESSAGE)
  if (!giftCardCustomAmountValue || !errorMessage) {
    return
  }
  if (input.length === 0) {
    deselectAmountOptions()
    errorMessage.innerHTML = ""
    errorMessage.style.display = 'none';
    // selectFirstAmountVariant()
    validateGiftCardForm()
  } else {
    let validInput = validateCustomAmount(input, errorMessage)
    if (validInput) {
      // The input is valid, do something with the number
      errorMessage.style.display = 'none';
      // picks from the available variants (amounts) radio buttons
      customAmountInput.setAttribute('data-input-active', true)
      selectAmountOptions(validInput)
      giftCardCustomAmountValue.value = validInput
      validateGiftCardForm(validInput)
    } else {
      errorMessage.style.display = 'flex';
      giftCardCustomAmountValue.value = null
      // selectFirstAmountVariant()
      // NOTE: SHOULD DISABLE THE ADD TO CART BUTTON HERE?
      // document.querySelector('button[data-action="add-to-cart"]').disabled = true
      validateGiftCardForm()
    }
  }

  if (document.querySelector(formSelectors.TYPE_PHYSICAL).checked) {
    resetChecksum()
    document.querySelectorAll('input[name="properties[_gift_option]"]').forEach((el) => {
      el.checked = false
      el.value = false
    })
    const isThisGiftCheckbox = document.querySelector(giftCardProperties.GIFT_OPTION)
    clearScheduleAtInput()
    isThisGiftCheckbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
  }
}

function handleTextareaInput(event) {
  const target = event.currentTarget;
  const maxLength = target.getAttribute("maxlength");
  const currentLength = target.value.length;
  const remaining_char = document.querySelector(formSelectors.REMAINING_CHAR)
  if (currentLength > 0) {
    remaining_char.classList.add('active')
  } else {
    remaining_char.classList.remove('active')
  }
  if (currentLength >= maxLength) {
    remaining_char.innerHTML = "You have reached the maximum number of characters."
    remaining_char.classList.add('input-error')
  } else {
    remaining_char.innerHTML = `${maxLength - currentLength} characters left.`
    remaining_char.classList.remove('input-error')
  }
  if (document.querySelector(formSelectors.TYPE_PHYSICAL).checked) {
    resetChecksum()
  }
}

function setHours(currentHour) {
  const dateHoursInput = document.querySelector(formSelectors.SCHEDULED_HOUR)
  const datePeriodInput = document.querySelector(formSelectors.PERIOD)
  if ( parseInt(currentHour.toString()) > 12) {
    // (0-11) is AM and (12-23) is PM
    dateHoursInput.value = currentHour % 12
    datePeriodInput.value = 'PM'
  } else {
    dateHoursInput.value = currentHour
  }
}

function updateTime() {
  // init the date inputs
  const currentDate = new Date()
  const dateInput = document.querySelector(formSelectors.SCHEDULED_DATE)
  const dateMinutesInput = document.querySelector(formSelectors.SCHEDULED_MINUTES)
  const hour = currentDate.getHours()
  const mins = currentDate.getMinutes()

  dateInput.valueAsDate = currentDate
  setHours(hour)

  if (mins > 0 && mins <= 15 ) {
    dateMinutesInput.value = 15
  } else if (mins > 15 && mins <= 30 ) {
    dateMinutesInput.value = 30
  } else if (mins > 30 && mins <= 45 ) {
    dateMinutesInput.value = 45
  } else if (mins > 45 ) {
    dateMinutesInput.value = 0
    // update the hours as its been offset by the mins to next hour
    setHours(hour + 1)
  } else {
    dateMinutesInput.value = 0
  }
}

function handleDateTimeInput (event) {
  const scheduledAt = document.querySelector(giftCardProperties.SCHEDULED_ON)
  const date = document.querySelector(formSelectors.SCHEDULED_DATE).value
  let hour = document.querySelector(formSelectors.SCHEDULED_HOUR).value
  const minutes = document.querySelector(formSelectors.SCHEDULED_MINUTES).value
  const period = document.querySelector(formSelectors.PERIOD).value
  if (period == 'PM' && parseInt(hour.toString()) <= 11) {
    hour = parseInt(hour.toString()) + 12
  }
  scheduledAt.value = `${date}T${hour.toString().padStart(2, '0')}:${minutes.padStart(2, '0')}`
  scheduledAt.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
}

if (typeof sendDateRadios === 'undefined' || sendDateRadios === null) {
  const sendDateRadios = document.querySelectorAll("[name='gift-card[send-date]']")
  for (let i = 0, max = sendDateRadios.length; i < max; i++) {
    sendDateRadios[i].onclick = function() {
      updateTime()
      const scheduledAt = document.querySelector(giftCardProperties.SCHEDULED_ON)
      scheduledAt.value = ""
      scheduledAt.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
      if (sendDateRadios[0].checked) {
        document.querySelector(formSelectors.SCHEDULED_CONTAINER).style.display = 'none';
      }
      if (sendDateRadios[1].checked) {
        handleDateTimeInput()
        document.querySelector(formSelectors.SCHEDULED_CONTAINER).style.display = 'flex';
      }
    }
  }
}

// clear custom input on click of variant amounts
function onVariantAmountClick (event) {
  clearAmountActiveState()
  event.target.classList.add('active')
  let giftCardCustomAmountErrorMessage = document.querySelector(formSelectors.ERROR_CUSTOM_AMOUNT_MESSAGE)
  let giftCardCustomAmountValue = document.querySelector(formSelectors.CUSTOM_AMOUNT_INPUT) 
  let giftCardCustomValidAmountValue = document.querySelector(giftCardProperties.CUSTOM_AMOUNT)
  giftCardCustomAmountErrorMessage.style.display = 'none';
  giftCardCustomAmountErrorMessage.innerHTML = ''
  giftCardCustomAmountValue.value = ''
  giftCardCustomAmountValue.removeAttribute('data-input-active')
  giftCardCustomValidAmountValue.value = null
  giftCardCustomValidAmountValue.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
  validateGiftCardForm()
}

function clearAmountActiveState() {
  document.querySelectorAll('li.HorizontalList__Item .SizeSwatch.active' ).forEach(item => {
    item.classList.remove('active')
  })
}

// Hide the last variant to keep to one line and attach the event listener to clear on click.
const hideExtraAmounts = () => {
  let options = document.querySelectorAll(formSelectors.VARIANT_OPTIONS)
  options.forEach(item => {
    label = item.querySelector('.SizeSwatch')
    if (!label) {
      return
    }
    if (label.innerHTML === '$2000') {
      item.classList.add(classes.HIDDEN)
    } else {
      label.addEventListener('click', (event) => {
        onVariantAmountClick(event)
      })
    }
})
}

function showMessageBox(event) {
  const message = document.querySelector('.gcp-input-row.message')
  const giftCardPostmanDiv = document.querySelector('#gift-card-postman')
  const buttonGiftCardMessage = document.querySelector('.gcp-input-row.gift-card-add-message-btn')
  const remaining_char = document.querySelector(formSelectors.REMAINING_CHAR)
  const textarea = document.querySelector(giftCardProperties.MESSAGE)

  if (!message || !giftCardPostmanDiv) {
    return
  }

  giftCardPostmanDiv.classList.add('active')
  if (!message.classList.toggle('active')) {
    textarea.value = ''
    textarea.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    event.target.innerHTML = 'add personal message'
    buttonGiftCardMessage?.setAttribute('data-handle', 'add')
    remaining_char.classList.remove(classes.ACTIVE)
  } else {
    event.target.innerHTML = 'remove'
    buttonGiftCardMessage?.setAttribute('data-handle', 'remove')

    if (textarea.value.length > 0) {
      remaining_char.classList.add(classes.ACTIVE)
    }
  }
}

function resetGcpProperties () {
  gcpProperties = [
    'input[name="properties[Recipient name]"]',
    'input[name="properties[Recipient email]"]',
    'input[name="properties[Message]"]',
    'input[name="properties[Scheduled At]"]',
    '#message'
  ]
  gcpProperties.forEach((property) => {
    let prop = document.querySelector(property);
    if (prop) {
      prop.value = '';
      prop.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    }
  })
  const isThisGiftCheckbox = document.querySelector(giftCardProperties.GIFT_OPTION)
  isThisGiftCheckbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
}

const attachListeners = () => {
  // console.warn('Attaching listeners')
  document.querySelector(giftCardProperties.RECIPIENTS_EMAIL)?.addEventListener('blur', validateGiftCardForm)
  document.querySelector(giftCardProperties.RECIPIENTS_NAME)?.addEventListener('blur', validateGiftCardForm)
  document.querySelector(giftCardProperties.RECIPIENTS_EMAIL)?.addEventListener('input', validateGiftCardForm)
  document.querySelector(giftCardProperties.RECIPIENTS_NAME)?.addEventListener('input', validateGiftCardForm)
  document.querySelector('#gift-card-hour')?.addEventListener('change', validateGiftCardForm)
  document.querySelector('#gift-card-minutes')?.addEventListener('change', validateGiftCardForm)
  document.querySelector('#gift-card-period')?.addEventListener('change', validateGiftCardForm)
  document.querySelector('.gcp-input-row.gift-card-add-message-btn div.property-option')?.addEventListener('click', showMessageBox)
  document.querySelector(formSelectors.SCHEDULED_DATE)?.addEventListener('input', () => {
    validateGiftCardForm()
    handleDateTimeInput()
  });
  document.querySelector(formSelectors.SCHEDULED_HOUR).addEventListener('input', handleDateTimeInput);
  document.querySelector(formSelectors.SCHEDULED_MINUTES).addEventListener('input', handleDateTimeInput);
  document.querySelector(formSelectors.PERIOD).addEventListener('input', handleDateTimeInput);
  const textarea = document.querySelector(giftCardProperties.MESSAGE)
  if (textarea.addEventListener) {
    textarea.addEventListener('input', handleTextareaInput, false);
  } else if (textarea.attachEvent) {
    textarea.attachEvent('onpropertychange', handleTextareaInput);
  }
  const giftCardTypeRadios = document.querySelectorAll('.line-item-property__field.type .gift-card-property-fields')
  giftCardTypeRadios.forEach((radioInput) => {
    radioInput.addEventListener('click', (event) => {
      onGiftCardTypeOptionClick(event)
    })
  })
  const customAmountInput = document.querySelector(formSelectors.CUSTOM_AMOUNT_INPUT)
  if (customAmountInput) {
    customAmountInput.addEventListener('input', (event) => {
      handleCustomInputEvent(event)
    })
  }
  // this is called from the theme.js file when a varient option is selected
  document.addEventListener('giftcard:error', showError)
  // ProductVariants: _onOptionChanged > _onVariantChanged > _updateAddToCartButton
  document.addEventListener('giftcard:validate', validateGiftCardForm)
  // should update the theme.js file to dispatch this event instead of having the logic repeated there.
  document.addEventListener('giftcard:added', () => {
    resetGcpProperties()
    document.querySelector(formSelectors.TYPE_DIGITAL).click()
    // Dangerous: unknown something is resetting the button back to an active state after the product is added...
    setTimeout(() => {
      console.warn('Gift card Product added successfully')
      disableAddToCartButton(true)
    }, 2000)
  })
}

const setTemplateId = () => {
  if (window.giftcard && window.giftcard.templateID) {
    let template = document.querySelector('#template_id')
    if (template) {
      template.value = window.giftcard.templateID
      template.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    }
  } else {
    console.warn('no template id to available for giftcard')
  }
}

function clearForm() {
  let selectors = [
    'properties[_gift_option]',
    'properties[Recipient name]',
    'properties[Recipient email]',
    'properties[Message]',
    'properties[Scheduled At]',
    'schedule[date]'
  ]

  selectors.forEach((selector) => {
    let removeEl = document.querySelector(`[name="${selector}"]`)
    if(removeEl) {
      removeEl.value = '';
      removeEl.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    }

    removeEl = document.querySelector(`[type="hidden"][name="${selector}"]`)
    if(removeEl) {
      removeEl.remove()
    }
  })
  const productForm = document.querySelector('form[action="/cart/add"]')
  const hiddenInputs = productForm.querySelectorAll('input[type="hidden"][name=""]')
  hiddenInputs.forEach((selector) => {
    selector.remove()
  })
  productForm.reset()
}

function setPropertyProduct() {
  const inputProductUrl = document.querySelector(giftCardProperties.PRODUCT_URL)

  if (inputProductUrl) {
    inputProductUrl.value = window.location.pathname
  }
}

window.addEventListener('load', () => {
  document.querySelector(formSelectors.TYPE_PHYSICAL)?.click()
  attachListeners();
  setTemplateId();
  disableAddToCartButton(true)
  hideExtraAmounts();
  document.querySelector(formSelectors.TYPE_DIGITAL)?.click()
  setPropertyProduct()
})
